import { styled } from 'next-yak'

import * as colors from '../constants/colors'
import * as effects from '../constants/effects'
import * as heading from './heading'
import * as image from './image'

export const CardWrapper = styled.a`
  align-items: center;
  border: 1px solid ${colors.PRIMARY_SAND_200};
  box-sizing: border-box;
  color: ${colors.TEXT_PRIMARY};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  overflow: hidden;
  padding: 10px;
  position: relative;
  text-decoration: none;
  max-width: 180px;

  &:hover {
    transition: all 200ms ease-in-out;
    box-shadow: ${effects.SHADOW_4};
  }

  ${image.Avatar} {
    height: auto;
    max-width: 160px;
    min-width: 100px;
    width: 160px;
  }
`

CardWrapper.displayName = 'S.userCard.CardWrapper'

export const CardName = styled(heading.XXXXXS)`
  color: ${colors.TEXT_SECONDARY};
  display: block;
  margin-top: 10px;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
`

CardName.displayName = 'S.userCard.CardName'
